import { render, staticRenderFns } from "./ProjectListCard.vue?vue&type=template&id=584d2b7a&scoped=true"
import script from "./ProjectListCard.vue?vue&type=script&lang=js"
export * from "./ProjectListCard.vue?vue&type=script&lang=js"
import style0 from "./ProjectListCard.vue?vue&type=style&index=0&id=584d2b7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584d2b7a",
  null
  
)

export default component.exports